import { MobileContentGems } from '@mc/api'
import { TrackingContainer } from '@mc/visibility'
import { trackSkillsYoullLearnViewed } from '../../events'
import { StickyCardDesktop } from './StickyCard'

export const ContentDesktop = ({
  mobileContentGems,
}: {
  mobileContentGems: MobileContentGems[]
}) => (
  <TrackingContainer onFirstVisible={trackSkillsYoullLearnViewed}>
    <div className='row no-gutters' style={{ margin: -8 }}>
      {mobileContentGems.map((gem, index) => (
        <StickyCardDesktop key={gem.id} gem={gem} index={index} />
      ))}
    </div>
  </TrackingContainer>
)
